import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Analytics: React.FC<IconProps> = ({
                                                  fill = COLORS.FG.SOFT,
                                                  width = 24,
                                                  height = 24,
                                                  className,
                                              }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Business / Statistics Column" width={width} height={height} x="0.000000"
                  y="0.000000"/>
            <path id="Union"
                  d="M4.49878 3L4.49878 19.2512C4.49878 19.3893 4.61071 19.5012 4.74878 19.5012L7.00003 19.5012L7.00003 19.5L7.00003 10C7.00003 9.44771 7.44775 9 8.00003 9L11 9C11.5523 9 12 9.44772 12 10L12 19.5L12 19.5012L14 19.5012L14 19.5L14 6C14 5.44772 14.4477 5 15 5L18 5C18.5523 5 19 5.44772 19 6L19 19.5L19 19.5012L21 19.5012L21 21.0012L4.74878 21.0012C3.78228 21.0012 2.99878 20.2177 2.99878 19.2512L2.99878 3L4.49878 3ZM8.50003 10.5L8.50003 19.5L10.5 19.5L10.5 10.5L8.50003 10.5ZM15.5 19.5L15.5 6.5L17.5 6.5L17.5 19.5L15.5 19.5Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
